// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes animate-skeleton{0%{transform:translateX(-100%) translateY(-50%)}to{transform:translateX(100%) translateY(-50%)}}.clickable-txt-2__icon-link{display:flex;gap:5px;align-items:center;cursor:pointer;color:var(--v-anchor-base)}.clickable-txt-2__icon-link.clickable-txt-2__icon-link--disabled{cursor:default;color:var(--v-disabled-base)}", ""]);
// Exports
module.exports = exports;
